var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.822 -15.995)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.686,14.834H.646A.661.661,0,0,1,0,14.159V11.518a.665.665,0,0,0,.646.618H7.1a.675.675,0,0,0,0-1.348H.646A.661.661,0,0,0,0,11.406L0,8.821a.665.665,0,0,0,.646.618H7.1a.675.675,0,0,0,0-1.348H.646A.661.661,0,0,0,0,8.709L0,6.124a.665.665,0,0,0,.646.619H7.1a.675.675,0,0,0,0-1.349H.646A.661.661,0,0,0,0,6.011L0,3.427a.665.665,0,0,0,.646.618H7.1A.675.675,0,0,0,7.1,2.7H.646A.661.661,0,0,0,0,3.315L0,.674A.661.661,0,0,1,.646,0H9.686a.662.662,0,0,1,.647.674V14.159A.662.662,0,0,1,9.686,14.834Z",
    transform: "translate(31.489 18.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e4e8ee",
    d: "M8.932,16.151a.416.416,0,0,0-.416-.143l-8.1,2A.645.645,0,0,0,0,18.662V33.329a.644.644,0,0,0,.413.655l8.1,2A.373.373,0,0,0,8.609,36a.438.438,0,0,0,.323-.153.764.764,0,0,0,.183-.513V16.663A.76.76,0,0,0,8.932,16.151Z",
    transform: "translate(26.822 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.1d9565d24dd207342ea7f5fbddfd39d0.svg";
export { ForwardRef as ReactComponent };